module.exports = __webpack_public_path__ + "img/EM2024.67a54292.png";